import { render, staticRenderFns } from "./ListAlertaView.vue?vue&type=template&id=06c50339&"
import script from "./ListAlertaView.vue?vue&type=script&lang=ts&"
export * from "./ListAlertaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports